export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20230318_0039_MR1_8295.35e36fa8.jpg";